import React from 'react'
import { Intent, Tag } from '@blueprintjs/core'
import { Flex } from '@ui'
import { IEmployeeDetails } from '@api'
import css from './employeeManagement.module.scss'

export default function EmployeeSpaceTag({
  employee,
  showRemoteMessage,
}: {
  employee: IEmployeeDetails
  showRemoteMessage?: boolean
}) {
  if (showRemoteMessage && employee.isRemote) {
    return <span style={{ color: 'var(--grey1)' }}>Remote</span>
  }

  let spaceTags: JSX.Element[] = []

  if (employee.spaceAssignment && employee.spaceAssignment.space) {
    spaceTags = [
      ...spaceTags,
      <div className={css.tag_wrapper} key={employee.spaceAssignment.space.externalId}>
        <Tag minimal round intent={Intent.PRIMARY}>
          <span className={css.space_code}>{employee.spaceAssignment.space.externalId}</span>
        </Tag>
      </div>,
    ]
  }

  if (employee.secondarySpaceAssignments.length) {
    spaceTags = [
      ...spaceTags,
      ...employee.secondarySpaceAssignments.map((ssa) => (
        <div className={css.tag_wrapper} key={ssa.space.externalId}>
          <Tag
            round
            key={ssa.space.externalId}
            style={{
              backgroundColor: 'gold',
              color: 'var(--black)',
            }}
          >
            {ssa.space.externalId}
          </Tag>
        </div>
      )),
    ]
  }

  if (employee.neighborhoods.length) {
    spaceTags = [
      ...spaceTags,
      ...employee.neighborhoods.map((n) => (
        <div className={css.tag_wrapper} key={n.id}>
          <Tag round style={{ backgroundColor: `#${n.color}` }}>
            {n.name}
          </Tag>
        </div>
      )),
    ]
  }

  return spaceTags.length ? (
    <Flex align="center" wrap="wrap">
      {spaceTags}
    </Flex>
  ) : (
    <Tag minimal round intent={Intent.DANGER}>
      Unseated
    </Tag>
  )
}
